import { render, staticRenderFns } from "./FeedRunDetail.vue?vue&type=template&id=3e81523b&"
import script from "./FeedRunDetail.vue?vue&type=script&lang=ts&"
export * from "./FeedRunDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports